import _ from 'lodash';

import * as constants from './AddressEdit.constants';
import * as services from './AddressEdit.service';

const state = {
  myAddresses: [],
};

const mutations = {
  [constants.UPDATE_ADDRESS_SUCCESS](state, myAddresses) {
    if (undefined !== myAddresses && null !== myAddresses) {
      state.myAddresses = myAddresses;
    }
  },

  [constants.UPDATE_ORDER_ADDRESS](state, order) {
    if (undefined !== order && null !== order) {
      if (undefined !== order.myAddresses && null !== order.myAddresses) {
        state.myAddresses = order.myAddresses;
      }
    }
  },
};

const actions = {
  async getStudentAddress({ commit }) {
    const res = await services.getStudentAddress();
    commit(constants.UPDATE_ADDRESS_SUCCESS, res.data.data);
    return res;
  },

  async makeNewAddress({ commit }, payload) {
    const res = await services.makeNewAddress(payload);
    commit(constants.UPDATE_ADDRESS_SUCCESS, res.data.data);
    return res;
  },

  async deleteAddress({ commit }, payload) {
    const res = await services.deleteAddress(payload);
    commit(constants.UPDATE_ADDRESS_SUCCESS, res.data.data);
    return res;
  },
};

const getters = {
  _myAddresses: (state) => {
    return _.map(state.myAddresses, (myAddress) => ({
      ...myAddress,
      displayMobile: myAddress.mobile.substring(0, 3) + '****' + myAddress.mobile.substring(7),
    }));
  },

  _myDefaultAddresses: (state, getters) => {
    return _.filter(getters._myAddresses, (myAddress) => myAddress.isDefault);
  },

  _myNotDefaultAddresses: (state, getters) => {
    let myAddresses = _.filter(getters._myAddresses, (myAddress) => !myAddress.isDefault);
    myAddresses = _.sortBy(myAddresses, (myAddress) => myAddress.addressOrder);
    return myAddresses;
  },

  myAddresses: (state, getters) => [
    ...getters._myDefaultAddresses,
    ...getters._myNotDefaultAddresses,
  ],

  myDefaultAddress: (state, getters) => {
    if (getters._myDefaultAddresses.length > 0) {
      return getters._myDefaultAddresses[0];
    } else {
      return null;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
